import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

function getList(params = {}) {
  const queryString = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');
  const url = queryString
    ? `${apiEndpoint.attachments}?${queryString}`
    : apiEndpoint.attachments;

  return axios
    .get(url, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

export const attachment = {
  getList,
  uploadFile,
  uploadFileToFolder,
  destroy,
  updateAttachment,
  bulkUpdate,
  bulkDelete,
  bulkDownload,
  getFolders,
  createFolder,
  updateFolder,
  deleteFolder,
  ensureSdsFolder,
};

function uploadFile(file, type = 'image', storage) {
  const fd = new FormData();

  fd.append('Attachment[file]', file);
  fd.append('type', type);
  if (storage) fd.append('storage', storage); // 's3' | 'filesystem' (nếu bạn dùng)

  return axios.post(apiEndpoint.attachments, fd, {
    headers: {
      ...authHeader(),
    }
  })
  .then(res => {
    if(res && res.status === 200){
      return res.data;
    }
  });
}
function uploadFileToFolder(file, folderId, corporateGroupId, onProgress) {
  const fd = new FormData();
  fd.append('Attachment[file]', file);
  if (folderId) fd.append('folder_id', folderId);
  if (corporateGroupId) fd.append('corporate_group_id', corporateGroupId);

  return axios.post(apiEndpoint.attachments, fd, {
    headers: { ...authHeader() },
    onUploadProgress: onProgress,
  }).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
  });
}

function updateAttachment(id, data) {
  return axios.put(
    apiEndpointFunction.attachments(id),
    data,
    { headers: authHeader() }
  ).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
  });
}

function getFolders(params = {}) {
  const queryString = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');
  const url = queryString
    ? `${apiEndpoint.attachmentFolders}?${queryString}`
    : apiEndpoint.attachmentFolders;

  return axios
    .get(url, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

function createFolder(data) {
  return axios
    .post(apiEndpoint.attachmentFolders, data, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

function updateFolder(id, data) {
  return axios
    .put(apiEndpointFunction.attachmentFolders(id), data, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

function deleteFolder(id) {
  return axios
    .delete(apiEndpointFunction.attachmentFolders(id), { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

function ensureSdsFolder(propertyId, corporateGroupId) {
  // Corporate scope wins — the backend reads corporate_group_id first and
  // returns the single corp-wide SDS folder. propertyId is only used in
  // single-property mode (no corporate group on the active property).
  const payload = corporateGroupId
    ? { corporate_group_id: corporateGroupId }
    : { property_id: propertyId };
  return axios
    .post(`${apiEndpoint.attachmentFolders}/ensure-sds-folder`,
      payload,
      { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

function bulkUpdate(payload) {
  return axios
    .post(`${apiEndpoint.attachments}/bulk-update`, payload, {
      headers: authHeader(),
    })
    .then(res => (res && res.status === 200 ? res.data : null));
}

function bulkDelete(payload) {
  return axios
    .post(`${apiEndpoint.attachments}/bulk-delete`, payload, {
      headers: authHeader(),
    })
    .then(res => (res && res.status === 200 ? res.data : null));
}

function bulkDownload(payload) {
  // Returns the binary response body directly (a Blob) rather than the
  // raw Axios envelope, mirroring bulkUpdate / bulkDelete which return
  // res.data. Callers can pass the result straight into `new Blob([...])`.
  return axios
    .post(`${apiEndpoint.attachments}/bulk-download`, payload, {
      headers: authHeader(),
      responseType: 'blob',
    })
    .then(res => (res && res.status === 200 ? res.data : null));
}

function destroy(id){
  return (
    axios
      .delete(
        apiEndpointFunction.attachments(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

